import type { ReactElement } from 'react';
import { Link } from 'react-router';

export interface CallbackNoticeProps {
  title: string;
  description: string;
  action: { to: string; label: string };
}

/**
 * 소셜 로그인이 끝나지 못했을 때의 안내.
 *
 * 막다른 길을 만들지 않는 것이 이 화면의 전부다 — 무슨 일이 있었는지 한 줄로 말하고,
 * 지금 할 수 있는 일을 하나 준다. 실패 사유를 자세히 적지는 않는다:
 * 어느 계정이 왜 막혔는지는 남의 계정을 떠보는 데 쓰일 수 있다.
 */
export function CallbackNotice({ title, description, action }: CallbackNoticeProps): ReactElement {
  return (
    <div className="u-container flex max-w-[30rem] flex-col items-center gap-5 py-24 text-center">
      <h1 className="text-[1.375rem] font-bold tracking-[-0.04em]">{title}</h1>
      <p className="text-[14px] leading-[1.8] text-muted-foreground">{description}</p>
      <Link
        to={action.to}
        className="inline-flex h-11 items-center rounded-md bg-primary px-5 text-sm font-semibold text-primary-foreground hover:bg-primary/85"
      >
        {action.label}
      </Link>
    </div>
  );
}
